const emojis = [
{ text: '[微笑]', name: 'smile'},
{ text: '[呲牙]', name: 'grin'},
{ text: '[色]', name: 'heart-eye'},
{ text: '[发呆]', name: 'daze'},
{ text: '[得意]', name: 'proud'},
{ text: '[流泪]', name: 'tears'},
{ text: '[害羞]', name: 'shy'},
{ text: '[闭嘴]', name: 'shut-up'},
{ text: '[睡]', name: 'sleeping'},
{ text: '[大哭]', name: 'cry'},
{ text: '[尴尬]', name: 'embarassed'},
{ text: '[发怒]', name: 'angry'},
{ text: '[调皮]', name: 'naughty'},
{ text: '[撇嘴]', name: 'pout'},
{ text: '[玫瑰]', name: 'rose'},
{ text: '[凋谢]', name: 'wither'},
{ text: '[爱心]', name: 'heart'},
{ text: '[心碎]', name: 'heartbreak'},
{ text: '[嘴唇]', name: 'lip'},
{ text: '[强]', name: 'good'},
{ text: '[弱]', name: 'weak'},
{ text: '[拥抱]', name: 'hug'},
{ text: '[冷汗]', name: 'cold-sweat'},
{ text: '[酷]', name: 'cool'},
{ text: '[难过]', name: 'sad'},
{ text: '[惊恐]', name: 'frightened'},
{ text: '[困]', name: 'sleepy'},
{ text: '[抓狂]', name: 'crazy'},
{ text: '[晕]', name: 'dizzy'},
{ text: '[美味]', name: 'yummy'},
{ text: '[嘘]', name: 'hiss'},
{ text: '[惊讶]', name: 'Surprised'},
{ text: '[糗大了]', name: 'shame'},
{ text: '[愉快]', name: 'happy'},
{ text: '[白眼]', name: 'roll-eyes'},
{ text: '[鼓掌]', name: 'applaud'},
{ text: '[傲慢]', name: 'arrogant'},
{ text: '[疑问]', name: 'doubt'},
{ text: '[偷笑]', name: 'smirking'},
{ text: '[吐]', name: 'gross'},
{ text: '[憨笑]', name: 'laughter'},
{ text: '[抠鼻]', name: 'nose'},
{ text: '[咒骂]', name: 'curse'},
{ text: '[奋斗]', name: 'struggle'},
{ text: '[悠闲]', name: 'Leisurely'},
{ text: '[惊吓]', name: 'scared'},
{ text: '[亲亲]', name: 'kiss'},
{ text: '[坏笑]', name: 'Smirk'},
{ text: '[阴险]', name: 'sinister'},
{ text: '[擦汗]', name: 'wipe-sweat'},
{ text: '[快哭了]', name: 'almose-cry'},
{ text: '[再见]', name: 'bye'},
{ text: '[委屈]', name: 'Wronged'},
{ text: '[鄙视]', name: 'despise'},
{ text: '[敲打]', name: 'beat'},
{ text: '[可怜]', name: 'poor'},
{ text: '[流汗]', name: 'sweat'},
{ text: '[哈欠]', name: 'yawn'},
{ text: '[右哼哼]', name: 'right-face'},
{ text: '[左哼哼]', name: 'left-face'},
{ text: '[衰]', name: 'bad-luck'},
{ text: '[猪头]', name: 'pig'},
{ text: '[饭]', name: 'rice'},
{ text: '[西瓜]', name: 'watermelon'},
{ text: '[蛋糕]', name: 'cake'},
{ text: '[OK]', name: 'ok'},
{ text: '[食指]', name: 'index-finger'},
{ text: '[ROCK]', name: 'rock'},
{ text: '[小手指]', name: 'litter-finger'},
{ text: '[拳头]', name: 'fist'},
{ text: '[勾引]', name: 'lure'},
{ text: '[抱拳]', name: 'holding-fist'},
{ text: '[胜利]', name: 'victory'},
{ text: '[握手]', name: 'shake-hands'},
{ text: '[足球]', name: 'football'},
{ text: '[篮球]', name: 'basketball'},
{ text: '[咖啡]', name: 'coffee'},
{ text: '[乒乓球]', name: 'ping-pong'},
{ text: '[啤酒]', name: 'beer'},
{ text: '[礼物]', name: 'gift'},
{ text: '[太阳]', name: 'sun'},
{ text: '[月亮]', name: 'moon'},
{ text: '[闪电]', name: 'lightning'},
{ text: '[昆虫]', name: 'insect'},
]

const EmojiUtil = {
  emojis: emojis,

  // 替换文字中的表情文字为图片span
  replaceEmojiText(content, scale) {
    content = content.replace(/\[([^\]]+)\]/g, (full, emojiText, index, whole) => {
      const style = this.getTextEmojiStyle(full, scale)

      if (style) {
        let str = ""
        for(var prop in style) {
          str += prop +':' + style[prop] + ';'
        }
        return `<span class="emoji" style="${str}"></span>`
      } else {
        return full
      }
    })

    return content
  },
  getTextEmojiStyle(text, scale) {
    scale = scale || 1

    // 对于特殊符号的处理
    // 老师点赞使用特殊表情“棒”来代替“强”
    text = text == '[棒]' ? '[强]' : text

    const emoji = this.text_indexed()[text]
    if (!emoji) { return null }

    const no = emoji.no
    const emojiWidth = (5692 / (2*83)) * scale
    const left = -no * emojiWidth
    return {
      'background-position': `${left}px 0`,
      'height': `${24 * scale}px`,
      'width': `${30 * scale}px`,
      'background-size': `${2880 * scale}px ${24 * scale}px`,
    }
  },
  getEmojiPosition(name, scale) {
    scale = scale || 1
    const emoji = this.name_indexed()[name]
    if (!emoji) { return null }

    const no = emoji.no
    const emojiWidth = (5692 / (2*83)) * scale
    const left = -no * emojiWidth
    return {
      'background-position': `${left}px 0`,
      'height': `${24 * scale}px`,
      'width': `${30 * scale}px`,
      'background-size': `${2880 * scale}px ${24 * scale}px`,
    }
  },
  text_indexed() {
    const indexed = {}
    this.emojis.forEach((item, i) => {
      item.no = i
      indexed[item.text] = item
    })

    return indexed
  },
  name_indexed() {
    const indexed = {}
    emojis.forEach((item, i) => {
      item.no = i
      indexed[item.name] = item
    })

    return indexed
  }
}

export default EmojiUtil



// WEBPACK FOOTER //
// ./src/utils/emoji.js